import React, { FC } from "react";
import { cn } from "helpers/style";
import styles from "./Upper.module.scss";

export type Step = "email" | "sms";
type Props = {
  activeStep: Step;
  onStepChange: (step: Step) => void;
};

const Upper: FC<Props> = ({ activeStep, onStepChange }: Props) => {
  return (
    <div className={styles.upper}>
      <button
        className={cn([
          styles.upperButton,
          activeStep === "email" && styles.upperButtonActive,
        ])}
        onClick={() => onStepChange("email")}
      >
        <span className={styles.upperButtonInner}>По почте</span>
      </button>

      <button
        className={cn([
          styles.upperButton,
          activeStep === "sms" && styles.upperButtonActive,
        ])}
        onClick={() => onStepChange("sms")}
      >
        <span className={styles.upperButtonInner}>По СМС</span>
      </button>
    </div>
  );
};

export default Upper;
